// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"Login_btnContainer__2XVui","loadContainer":"Login_loadContainer__3eIUx","login":"Login_login__3cGGL","recoverAccountBtn":"Login_recoverAccountBtn__4O3Ku"};